import { type TGlobalFunctionTyped } from 'common/hooks/useTranslation';

import { type CardActivity } from '../../hooks/useCardActivityQuery';
import { type CardLoad } from '../../hooks/useCardLoadsQuery';

export const getLoadedBy = (
  load: CardLoad,
  translator: TGlobalFunctionTyped,
) => {
  let additionalString = '';
  if (!load.request) {
    return translator('cards.activity.feed.loadedBy', { name: load.by_user });
  }

  if (load.request.auto_approved) {
    additionalString = translator('cards.activity.feed.auto');
  } else {
    const appraisals = load.request.appraisals.filter(
      (appr) => appr.approver_id !== load.by_user_id,
    );
    additionalString = translator('cards.activity.feed.approvedBy', {
      name: appraisals.map((a) => a.approver.fullname).join(', '),
    });
  }

  return `${translator('cards.activity.feed.loadedBy', {
    name: load.by_user,
  })} ${additionalString}`;
};

export const titleFromActivityType = (
  activity: CardActivity,
  t: TGlobalFunctionTyped,
) => {
  switch (activity.activity_type) {
    case 'ordered':
      return t('cards.activity.feed.ordered', { name: activity.user.fullname });
    case 'activated':
      return t('cards.activity.feed.activated', {
        name: activity.user.fullname,
      });
    case 'blocked':
      return t('cards.activity.feed.blocked', { name: activity.user.fullname });
    case 'unblocked':
      return t('cards.activity.feed.unblocked', {
        name: activity.user.fullname,
      });
    case 'paused':
      return t('cards.activity.feed.paused');
    case 'unpaused':
      return t('cards.activity.feed.unpaused');
    case 'lost':
      return t('cards.activity.feed.lost');
    case 'stolen':
      return t('cards.activity.feed.stolen');
    case 'damaged':
      return t('cards.activity.feed.damaged');
    case 'sms-pin-sent':
      return t('cards.activity.feed.smsPinSent');
    case 'sms-pin-set':
      return t('cards.activity.feed.smsPinSet');
    case 'budget-changed':
      return t('cards.activity.feed.budgetChanged');
    case 'allow-withdrawal':
      return t('cards.activity.feed.allowWithdrawal', {
        name: activity.user.fullname,
      });
    case 'deny-withdrawal':
      return t('cards.activity.feed.denyWithdrawal', {
        name: activity.user.fullname,
      });
    case 'allow-onlineUsage':
      return t('cards.activity.feed.allowOnlineUsage', {
        name: activity.user.fullname,
      });
    case 'deny-onlineUsage':
      return t('cards.activity.feed.denyOnlineUsage', {
        name: activity.user.fullname,
      });
    case 'allow-contactless':
      return t('cards.activity.feed.allowContactless', {
        name: activity.user.fullname,
      });
    case 'deny-contactless':
      return t('cards.activity.feed.denyContactless', {
        name: activity.user.fullname,
      });

    case 'active':
      return t('cards.activity.feed.active');

    default:
      return null;
  }
};
